import { render, staticRenderFns } from "./Hints.vue?vue&type=template&id=112f0daa&scoped=true&lang=pug"
import script from "./Hints.vue?vue&type=script&lang=js"
export * from "./Hints.vue?vue&type=script&lang=js"
import style0 from "./Hints.vue?vue&type=style&index=0&id=112f0daa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f0daa",
  null
  
)

export default component.exports